import { Button as AntButton, Modal, Table, TableColumnsType } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { getTargetStudents } from "../../../api/tutor.api";
import useAxios from "../../../hooks/useAxios";
import config from "../../../lib/config";
import { IGetTargetStudents, ITargetStudent } from "../../../models/tutor.model";
import { ITutorClass } from "../../../models/tutor/tutorClass.model";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import Pagination from "../../Pagination";
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../../store/rootReducer';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  record: ITutorClass|undefined;
  date: string;
}

const TargetStudentModal: FC<IProps> = ({
  visible,
  setVisible,
  record,
  date,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetTargetStudents>();
  const history = useHistory();
  const { currentCampus } = useSelector((state: RootState) => state.auth);

  const [pageNo, setPageNo] = useState(1);
  const onHandleFindStudent = (record: ITargetStudent) => {
    history.push(`/student/student?campusCode=${currentCampus}&memberCode=${record.memberCode}&field=studentName&keyword=${record.memberKorName}`);
  }


  useEffect(() => {
    if (record && date) {
      execute(getTargetStudents(record.classCode, date));
    }
  }, [record, date]);

  const columns: TableColumnsType<ITargetStudent> = [
    {
      title: t('class.tutor.column4'),
      dataIndex: 'memberKorName',
      align: 'center',
      render: (value, record) => {
        return <span className="text text-underline pointer" onClick={() => onHandleFindStudent(record)}>{value}</span>
      }
    },
    {
      title: t('class.tutor.column5'),
      dataIndex: 'attendanceRate',
      align: 'center',
      render: value => (
        <span className={value < 70 ? 'text-danger' : ''}>
          {typeof value === 'number' ? `${value}%` : '-'}
        </span>
      )
    },
    {
      title: t('class.tutor.column1'),
      dataIndex: 'applyRate',
      align: 'center',
      render: value => (
        <span className={value < 60 ? 'text-danger' : ''}>
          {typeof value === 'number' ? `${value}%` : '-'}
        </span>
      )
    },
    {
      title: t('class.tutor.column2'),
      dataIndex: 'avgScore',
      align: 'center',
      render: value => (
        <span className={value < 30 ? 'text-danger' : ''}>
          {typeof value === 'number' ? `${value}%` : '-'}
        </span>
      )
    },
  ];

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Modal
        title={t('class.tutor.column3')}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={() => setVisible(false)}
            >
              {t('common.button.confirm')}
            </AntButton>
          </div>
        ]}
      >
        <div className="comm-table__area">
          <Table
            columns={columns}
            dataSource={res?.data}
            pagination={{
              current: pageNo,
              pageSize: config.miniPageSize,
            }}
          />
        </div>
        <div className="comm-bx__space">
          <div className="common-paging center">
            <Pagination
              count={res?.data?.length || 0}
              page={pageNo}
              setPage={setPageNo}
              mini
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default TargetStudentModal;
